import script from "./CategoryBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryBar.vue?vue&type=script&setup=true&lang=js"

import "./CategoryBar.vue?vue&type=style&index=0&id=4701e553&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4701e553"]])

export default __exports__